import MenuSectionItemList, { MenuSectionItemListProps } from './MenuSectionItemList';

export type { MenuSectionItemListProps };
export default MenuSectionItemList;
